import { securitySwitchOrganizationPostAsyncSlice } from './post';

export const {
	requestPostSecuritySwitchOrganization,
	resetPostSecuritySwitchOrganization
} = securitySwitchOrganizationPostAsyncSlice.asyncActionCreators;
